import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiErrorDetail } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Flame } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[#0a1930]" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <span className="inline-flex w-12 h-12 rounded-full border border-gold/70 items-center justify-center mb-4">
            <Flame className="w-6 h-6 text-gold" />
          </span>
          <h1 className="font-display text-3xl text-white">Council Admin</h1>
          <p className="text-sm text-zinc-500 mt-2">Assembly of Yahweh Shammah</p>
        </div>
        <form onSubmit={submit} className="border hairline rounded-xl p-8 surface space-y-5">
          <div>
            <Label className="text-zinc-300">Email</Label>
            <Input type="email" data-testid="admin-login-email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 bg-black/40 border-zinc-800" />
          </div>
          <div>
            <Label className="text-zinc-300">Password</Label>
            <Input type="password" data-testid="admin-login-password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 bg-black/40 border-zinc-800" />
          </div>
          <Button type="submit" data-testid="admin-login-submit" disabled={loading} className="w-full bg-gold text-black hover:bg-slate-200">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
        </form>
      </div>
    </div>
  );
}
